const initialState = { 
    message: null, 
    messageType: 'alert alert-success',
}


const messageReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SYSMESSAGE':
            return {
                ...state,
                message: action.message, 
                messageType: action.messageType, 
            };
        default: 
            return state;
    }
}
export default messageReducer;

/*
const messageReducer = (state = '', action) => {
    switch(action.type){
        case 'SYSMESSAGE':
            return action.payload;
            
            //return {
            //    ...state,
            //    message: action.payload,
            //}
        default:
            return state;
    }
}
export default messageReducer;
*/
